import type { IntercomProps } from 'react-use-intercom';

import type { IExtendedUserDetails } from '@sine/auth-client';

export function mapUserDetailsToIntercomProps(
  userDetails: IExtendedUserDetails | undefined,
): IntercomProps | undefined {
  if (!userDetails) {
    return undefined;
  }

  const isSystemAdminImpersonating = !!userDetails.administeredBy?.permissions.includes('SYSTEM_ADMIN');
  const user = isSystemAdminImpersonating ? userDetails.administeredBy! : userDetails;

  return {
    userId: user.id,
    userHash: user.crmId,
    email: user.email,
    name: `${user.firstName} ${user.lastName}`,
  };
}
